import { useState } from 'react';
import { DetailsPanel, EditIcon, FormatInformation, IconButton } from '@weareopenr/component-library';
import styles from './ProductDetailsPanel.module.scss';
import { IMenuItem } from 'src/types/menu.types';
import { ClaimsCode, NO_INVENTORY_TYPES, REGULATORY_STATEMENTS } from 'src/constants';
import GlobalItemDetailsEditModal from '../GlobalItemDetailsEditModal';
import { hasRegulatoryStatement } from 'src/utils/regulatory-statements';
import { HFSSTooltip } from '../HFSSTooltip/HFSSTooltip';

export interface ProductDetailsPanelProps {
  item: IMenuItem;
}

const renderHFSS = (modalItem: IMenuItem) => {
  const isHFSS = hasRegulatoryStatement(modalItem.regulatory_statements, REGULATORY_STATEMENTS.HFSS.name);
  return (
    <FormatInformation heading="Contains High Fat, Salt or Sugar" tooltip={<HFSSTooltip />}>
      {isHFSS ? 'Yes' : 'No'}
    </FormatInformation>
  );
};

const ProductDetailsPanel = ({ item }: ProductDetailsPanelProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);
  const recipe = item.recipe;
  const containsAlcohol = recipe?.claims.some((claim) => claim.code === ClaimsCode.ALCOHOL) ?? false;
  const modalItem = recipe ? { ...item, containsAlcohol: containsAlcohol } : item;

  return (
    <>
      <GlobalItemDetailsEditModal isModalOpen={isModalOpen} onModalClose={handleModalClick} currentItem={modalItem} />
      <DetailsPanel
        title="Product Details"
        action={
          <IconButton
            onClick={handleModalClick}
            aria-label="Edit product details"
            icon={EditIcon}
            buttonStyle="ghost"
          />
        }
      >
        <FormatInformation heading="Name">{item.name}</FormatInformation>
        {item.code && <FormatInformation heading="Reference Code">{item.code}</FormatInformation>}
        <FormatInformation heading="Consumer name">{item.consumerName || 'No Consumer Name'}</FormatInformation>
        <FormatInformation heading="Description">{item.description || 'No Description'} </FormatInformation>
        <FormatInformation heading="Product Range">
          {item.ranges?.length > 0 ? (
            <ul className={styles['range-list']}>
              {item.ranges.map((range) => (
                <li key={range.name}>{range.name}</li>
              ))}
            </ul>
          ) : (
            'No Product Range'
          )}
        </FormatInformation>
        {!NO_INVENTORY_TYPES.includes(item.type) && recipe && (
          <FormatInformation heading="Contain Alcohol (> 0.5%)">{containsAlcohol ? 'Yes' : 'No'} </FormatInformation>
        )}
        <FormatInformation heading="Default POS ID">{item.plu || 'No Default POS ID'} </FormatInformation>
        <FormatInformation heading="Age Verification Required?">
          {hasRegulatoryStatement(modalItem.regulatory_statements, REGULATORY_STATEMENTS.AGE_VERIFICATION.name)
            ? 'Yes'
            : 'No'}
        </FormatInformation>
        {!NO_INVENTORY_TYPES.includes(item.type) && recipe && renderHFSS(modalItem)}
      </DetailsPanel>
    </>
  );
};
export default ProductDetailsPanel;
